var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNsepoxy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.772,
    height: 61.249,
    viewBox: "0 0 226.772 61.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1647",
    "data-name": "Rectangle 1647",
    width: 226.772,
    height: 61.249,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17585",
    "data-name": "Path 17585",
    d: "M82.042,40.768l4.439,0-.017-13.772c.7.268.579.24,1.1.818a8.112,8.112,0,0,0,1.03.922c2.055,1.7,13.456,12.576,14.336,12.994l.012-24.647-4.635,0L98.4,31.142c-.9-.353-5.105-4.607-6.205-5.649l-8.116-7.5a10.619,10.619,0,0,0-2.157-1.8c.053,3.221-.215,23.372.118,24.573",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17586",
    "data-name": "Path 17586",
    d: "M66.333,61.249h3.288L69.641,0H66.31Z",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17587",
    "data-name": "Path 17587",
    d: "M137.822,17.793l.066,22.985,16.226,0a28.315,28.315,0,0,0,.094-4.532H142.44l.03-5.1h9.987l.007-4.478-10.032,0,0-5.045,11.28-.03.055-4.443c-1.6-.186-12.918-.063-15.939-.062Z",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17588",
    "data-name": "Path 17588",
    d: "M162.524,27.961l-.116-.261c-.014-.039-.079-.219-.1-.274-.053-.174-.08-.4-.149-.574-.339-.832-1.539-.458-3.818-.456-.274,1.124-.11,18.452-.1,21.067l4.412-.008V39.592c1.08.45,3.769,2.96,8.176.711,2.239-1.144,3.791-3.4,3.717-6.9-.13-6.216-5.45-9.812-12.031-5.44M165.3,29.93a3.863,3.863,0,0,1,1.935,7.478c-2.183.691-4.467-.577-4.549-2.572-.08-1.955-.437-4.258,2.614-4.906",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17589",
    "data-name": "Path 17589",
    d: "M108.979,34.862l-1.929,3.471c1.914,2.519,12.047,4.909,15.229-1.175,1.717-3.286.64-7.612-3.8-9.566-1.692-.745-3.709-1.335-4.8-2.48-1.631-1.717-.463-3.815,1.993-3.965,2.743-.168,3.855,1.031,5.86,1.616l1.7-3.569c-.867-.368-1.479-.816-2.433-1.2-4.861-1.972-11.188-1.028-12.384,4.063-1.152,4.906,1.735,7,5.537,8.643,1.572.68,3.86,1.539,4.172,3.112.466,2.348-1.85,3.214-4.016,3.068-2.477-.168-3.461-1.251-5.132-2.015",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17590",
    "data-name": "Path 17590",
    d: "M183.033,26.291c-9.8,2.026-7.153,17.1,3.89,14.64,9.157-2.042,7.135-16.917-3.89-14.64m1.226,3.543c4.537-.921,5.438,6.495,1.388,7.526-4.591,1.168-5.891-6.612-1.388-7.526",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17591",
    "data-name": "Path 17591",
    d: "M213.625,47.462l4.283,0,8.864-20.729-3.948-.031-3.646,8.127c-.267-.256-.13-.067-.335-.44-.063-.113-.17-.355-.226-.479-.166-.369-.268-.623-.431-.988l-2.766-6.213-4.845,0c.217,1.129,5.045,10.435,6.045,12.775.38.89-.273,1.755-.668,2.645-.741,1.669-1.773,3.641-2.327,5.335",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17592",
    "data-name": "Path 17592",
    d: "M199.025,33.756c-.978,1.4-4.5,5.921-4.968,7,5.091.069,3.959.631,7.148-4.125,1.2,1.025,2.1,2.978,3.286,4.126l5.177.011c-.121-.76-4.573-5.936-5.3-7.364.92-1.552,4.223-5.725,4.6-6.686l-4.327,0-2.309,3.931c-1.316-.872-2.259-3.946-3.788-3.944l-4.7.029a34.716,34.716,0,0,0,2.583,3.464Z",
    fill: "#09446e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17593",
    "data-name": "Path 17593",
    d: "M0,48.462A37.827,37.827,0,0,1,3.536,50.09c2.893,1.386,23.032,11.05,23.816,11.159l0-2.837L9.139,49.825c-.843-.4-5.35-2.385-5.975-3.005a6.59,6.59,0,0,1-2.9-1.359L0,45.482Z",
    fill: "#dae655",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17594",
    "data-name": "Path 17594",
    d: "M0,19.365A58.62,58.62,0,0,1,7.031,22.72a8.246,8.246,0,0,1,1.6.638c.26.115.49.182.742.322.686.38.28.011.588.534a54.4,54.4,0,0,1,6.738,2.965c.39.288.173-.048.36.4a4.7,4.7,0,0,1,3,1.379A16.622,16.622,0,0,1,23.7,30.469a19.3,19.3,0,0,0,3.64,1.576l.005-2.763-.331.043c-.886-.964-2.806-1.141-3.566-2.057a6.014,6.014,0,0,1-2.918-1.436c-.656.1-4.47-1.878-5.466-2.354-.335-.16-.551-.245-.847-.378-.814-.364-.677-.415-.741-.69-.636.211-.953-.114-1.661-.463a5.425,5.425,0,0,1-1.453-.816,20.71,20.71,0,0,1-3.612-1.573L3.617,18.081c-.415-.291-.151-.052-.376-.352a7.1,7.1,0,0,1-3-1.359H0Z",
    fill: "#dae655",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17595",
    "data-name": "Path 17595",
    d: "M0,38.852a25.267,25.267,0,0,1,3.593,1.6L6.15,41.641c.532.238.592.155.692.582a3.8,3.8,0,0,1,1.809.627c.549.271,1.251.382,1.1.815,1.49-.075,15.7,7.479,17.618,7.911l-.057-2.916c-1.048-.3-5.589-2.551-7.044-3.227l-6.141-2.911c-.666-.306-.509-.116-.834-.627-.816.015-.894-.173-1.564-.516-.3-.153-.531-.224-.737-.334-.814-.438-.322.048-.636-.592-.789.13-5.083-2.1-6.367-2.7-.692-.325-.515-.1-.816-.661a5.8,5.8,0,0,1-3-1.387L0,35.732Z",
    fill: "#dae655",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17596",
    "data-name": "Path 17596",
    d: "M0,29.06a24.756,24.756,0,0,1,3.624,1.613l2.534,1.162c.628.322.69.091.691.767.552-.312.939.036,1.591.349.29.14.58.25.862.394.632.322.5.132.514.531,1.05.011,4.989,2.063,6.464,2.763.695.33.555.1.759.679.528-.171,2.031.546,2.6.936.471.322.17.067.418.387,1.2.009,6.051,2.994,7.256,3.1l.026-2.828L24.389,37.6c-.822-.382-.526-.07-.847-.689a4.326,4.326,0,0,1-2.992-1.391,3.518,3.518,0,0,1-1.959-.664c-.715-.33-1.031-.483-1.8-.859-.5-.244-3.195-1.35-3.467-1.822a6.093,6.093,0,0,1-2.943-1.4,14.4,14.4,0,0,1-3.7-1.554c-.649-.31-1.166-.543-1.807-.848-1.217-.579-1.238-.4-1.527-1.051A4.668,4.668,0,0,1,.3,25.941l-.3.09Z",
    fill: "#dae655",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17597",
    "data-name": "Path 17597",
    d: "M.242,16.37a7.084,7.084,0,0,0,3,1.358c6.777-3.521,15.19-7.338,22.371-10.872,1.865-.918,1.461-1.072,3.341-.1L54.627,19.2l.016-2.847L27.478,3.24c-.64-.052-5.885,2.675-6.925,3.172Z",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17598",
    "data-name": "Path 17598",
    d: "M10.36,21.13a5.425,5.425,0,0,0,1.453.816c.708.349,1.025.674,1.661.463a50,50,0,0,0,5.072-2.4c1.737-.916,3.367-1.65,5.123-2.5,4.282-2.079,3.254-2.021,5.308-1.015C31.445,17.7,53.611,28.626,54.611,28.858c.046-3.4.553-2.523-2.56-4.029-.938-.453-1.835-.884-2.751-1.334L32.71,15.428c-6.1-3.1-4.791-2.877-8.478-1.081-.967.471-1.908.962-2.846,1.409Z",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17599",
    "data-name": "Path 17599",
    d: "M20.55,35.516a4.327,4.327,0,0,0,2.992,1.391c.843-.256,3.362-1.723,3.918-1.663.308.033,3.311,1.524,3.856,1.8l19.345,9.4c1.156.555,2.848,1.471,3.963,1.855l.024-2.824L27.784,32.361c-1.239-.036-5.765,2.547-7.234,3.155",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17600",
    "data-name": "Path 17600",
    d: "M20.528,25.832a6.014,6.014,0,0,0,2.918,1.436c5.12-1.851,1.775-2.841,7.755-.039,2.951,1.383,22.432,11.115,23.428,11.32l.019-2.658c-.744-.663-6.931-3.5-8.4-4.207L29.168,23.4c-2.49-1.212-1.881-.8-4.361.393-1.42.681-2.841,1.427-4.279,2.039",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17601",
    "data-name": "Path 17601",
    d: "M17.039,37.318l-6.684,3.134c.314.64-.178.155.636.592.206.11.438.181.737.334.67.344.748.532,1.564.517a29.612,29.612,0,0,0,3.385-1.576c1.087-.495,2.353-1.152,3.381-1.678-.248-.32.053-.066-.418-.387-.57-.39-2.073-1.108-2.6-.936",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17602",
    "data-name": "Path 17602",
    d: "M.3,25.941a4.668,4.668,0,0,0,3.046,1.377A22.956,22.956,0,0,0,6.59,25.8c.6-.305,1.076-.527,1.68-.8a17.63,17.63,0,0,1,1.686-.783c-.308-.524.1-.155-.587-.535-.253-.14-.483-.206-.742-.321a8.2,8.2,0,0,0-1.6-.639Z",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17603",
    "data-name": "Path 17603",
    d: "M6.849,32.6A23.641,23.641,0,0,0,3.4,34.145a33.471,33.471,0,0,1-3.23,1.562,5.809,5.809,0,0,0,3,1.386l6.645-3.217c-.016-.4.118-.209-.514-.532-.282-.144-.572-.254-.863-.393-.651-.313-1.039-.661-1.59-.349",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17604",
    "data-name": "Path 17604",
    d: "M10.378,30.771a6.093,6.093,0,0,0,2.943,1.4c2.261-.9,4.524-2.355,6.73-3.213a4.691,4.691,0,0,0-3-1.379Z",
    fill: "#80bc4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17605",
    "data-name": "Path 17605",
    d: "M.264,45.461a6.612,6.612,0,0,0,2.9,1.359L9.75,43.665c.152-.433-.55-.545-1.1-.816a3.8,3.8,0,0,0-1.808-.627Z",
    fill: "#80bc4d",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsepoxy);
export default __webpack_public_path__ + "static/media/nsepoxy.ffb723dbbb2796b82c1f9634ba042c75.svg";
export { ForwardRef as ReactComponent };